import {HTTP} from "./common";

export const RatingApi = {

    get_xls_rating() {
        return HTTP.get(`services/get_xls_rating/`).then((response) => {
            return response.data;
        });
    },
    start_parse_xls_rating(data) {
        return HTTP.post(`services/start_parse_xls_rating/`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((response) => {
            return response.data;
        });
    },


};


